import { PagesCommonProps } from "./pagesUtil";

export const selectedDataRowForPieDefaultState = [
  ["Courses", "Percentages"],
  ["Complete", 0],
  ["Incomplete", 0],
];

export const courseBreakdownOnRowSelect = (
  e: React.MouseEvent<HTMLSpanElement>,
  data: any,
  setHoveredRowStye: React.Dispatch<React.SetStateAction<{ top?: number; left?: number } | null>>,
  setSelectedDataRowForPie: React.Dispatch<React.SetStateAction<(string | number)[][]>>,
  setExtraDataForPie: React.Dispatch<React.SetStateAction<Record<string, string | number>>>
) => {
  if (data) {
    setSelectedDataRowForPie([
      ["Courses", "Percentages"],
      ["Complete", +(data?.completed || 0)],
      ["Incomplete", +(data?.incomplete || 0)],
    ]);

    setExtraDataForPie({
      "No. of Completed": data?.noOfCompleted || 0,
      "No. of Incomplete": data?.noOfIncomplete || 0,
    });

    // Get exact position of the clicked element
    const targetElement = e.currentTarget;
    const rect = targetElement.getBoundingClientRect();

    // Position the hover chart next to the hovered element
    setHoveredRowStye({
      top: rect.top + window.scrollY - 350, // Center vertically relative to the row
      left: rect.left + window.scrollX // Position to the right of the text with some offset
    });
  } else {
    setHoveredRowStye(null);
  }
};


export const numberOfCompletedCoursesOtherActions = (
  otherActions: (key: any, params: Record<string, any>) => Promise<void>,
  data?: any
) => {

  const currentCompletedCourses = data?.fetchNumberOfCoursesData?.completedCourses || "true";
  const completedCourses = currentCompletedCourses === "true" ? "false" : "true";

    return [
    {
      text: `Show ${currentCompletedCourses === "true" ? "Incompleted" : "Complete"}`,
      action: () => {
        otherActions("fetchNumberOfCoursesData", {
          completedCourses,
        });
      },
    },
  ];
}

export const organisationsWithCoursesOtherActions = (
  key: string,
  otherActions: (key: any, params: Record<string, any>) => Promise<void>,
  data?: any
) => {

  const currentWithCourses = data?.[key]?.withCourses || "true";
  const withCourses = currentWithCourses === "true" ? "false" : "true";
  return [
    {
      text: `Show ${currentWithCourses === "true" ? "Without" : "With"}`,
      action: () => {
        otherActions(key, {
          withCourses,
        });
      },
    },
  ];
}

export const showCourseNamesOnRowSelect = (
  chartId: string,
  { chartWrapper }: any,
  data: any,
  setHoveredRowStye: React.Dispatch<React.SetStateAction<{ top?: number, left?: number } | null>>,
  setSelectedDataRowForTable: React.Dispatch<React.SetStateAction<(string | string)[][]>>
) => {
  const chart = chartWrapper.getChart();
  const selection = chart.getSelection();
  if (selection.length > 0) {
    const row = selection[0].row;
    const rowData = (data?.data)[row + 1][0];
    
    const dataRows = data?.usersOnDates[rowData];
    if(dataRows) setSelectedDataRowForTable([
      ["Course"],
      ...dataRows,
    ])
    const targetElement = document.querySelector(`.${chartId}`);

    if (targetElement) {
      const rect = targetElement.getBoundingClientRect();
      setHoveredRowStye({
        top: rect.top + (window.scrollY) + 200, // Adjust for scrolling
        left: rect.left + window.scrollX + rect.width, // Move to the right edge
      });
    }
  } else {
    setHoveredRowStye(null);
  }
}